import BpkMobileScrollContainer from '@skyscanner/backpack-web/bpk-component-mobile-scroll-container';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import ReviewImage from './ReviewImage';
import ReviewImagesSwiper from './ReviewImagesSwiper';

import type { ImagesListClickEventHandler, ImagesItem } from '../types';

import STYLES from './ReviewImagesList.module.scss';

import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';

const cls = cssModules(STYLES);

type Props = {
  images: ImagesItem[];
  onClick?: ImagesListClickEventHandler;
  showAllTravellerImages?: boolean;
  useSmallerImage?: boolean;
  reviewIndex?: number;
};

const ReviewImagesList = ({
  images,
  onClick,
  reviewIndex,
  showAllTravellerImages,
  useSmallerImage = false,
}: Props) => (
  <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
    {(isMobile: boolean) =>
      isMobile ? (
        <BpkMobileScrollContainer>
          <div className={cls('ReviewImagesList')}>
            {images.map(({ src }, index) => (
              <ReviewImage
                key={src}
                src={src}
                imageIndex={index}
                onClick={(e) => onClick?.(e, index)}
                useSmallerImage={useSmallerImage}
              />
            ))}
          </div>
        </BpkMobileScrollContainer>
      ) : (
        <ReviewImagesSwiper
          images={images}
          onClick={onClick}
          showAllTravellerImages={showAllTravellerImages}
          reviewIndex={reviewIndex}
        />
      )
    }
  </BpkBreakpoint>
);

export default ReviewImagesList;
